module.exports = __webpack_public_path__ + "static/media/4_browse.5eb3cdf9.png";